import { News } from "./table_typing"

export interface tableState {
    model:{
            newslist:News[],
        }
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    model:{
        newslist: [
    {
        "uuid": "",
        "title": "",
        "description": "",
        "link": "",
        "tag": "",
        "image": "",
        "source": "",
        "published": ""
    }
        ] as News[]
        }
        ,
        view:{
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        model:{
            newslist:toCopy.model.newslist.map((news) =>
            {
                return {
                    ...news,
                }
            })
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}